<app-accordion-help [helps]="helps"></app-accordion-help>
<ng-container *ngIf="is_loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>


<div style="margin-top: 20px; margin-left: 20px">
  <button mat-raised-button color="primary" (click)="goBack()">Back</button>
</div>



<ng-container *ngIf="!is_loading">

<ng-container *ngIf="!is_webhook_id ">

<div style="margin-top: 20px; margin-left: 20px">
  <button mat-raised-button color="primary" (click)="onAdd()">Add Clickfunnels</button>
</div>
</ng-container>



<ng-container *ngIf="is_code">


  <div ngClass.xs="page-margin-xs"
       ngClass.sm="page-margin-sm"
       ngClass="page-margin" style="margin-top: 20px; margin-left: 20px">
    <mat-card>

      <mat-card-content>
        <pre><code>
          https://webhook.{{DOMAIN}}/webhooks/click_funnels/{{account_id}}
        </code></pre>
      </mat-card-content>
    </mat-card>

  </div>

  <!--  <button (click)="changeTheme()">Change theme</button>-->

</ng-container>

</ng-container> <!-- end is loading-->
